export const detailUrl = ({ id }) => `/companies/detail/${id}/invoicing`;
